/* Velvane — interacciones ligeras del rediseño.
   Movimiento: CSS para hover y cambios pequeños (velvane.css), Motion (vv-motion.js)
   para entradas y cambios de estado, y GSAP + ScrollTrigger solo para la escena
   de «Así de sencillo». Todo respeta prefers-reduced-motion y nada bloquea la
   lectura ni los clics: si un efecto no llega a ejecutarse, el contenido ya está. */
(function () {
  'use strict';

  /* ---------- Movimiento: utilidades ---------- */
  var reduceQuery = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var EASE = [0.22, 1, 0.36, 1];
  function prefersReduced() { return !reduceQuery || reduceQuery.matches; }
  function motion() {
    if (!window.VVMotion || prefersReduced()) return null;
    return window.VVMotion;
  }
  function play(el, keyframes, options) {
    var m = motion();
    if (!m || !el) return null;
    var o = { duration: 0.3, ease: EASE };
    for (var k in options) o[k] = options[k];
    return m.animate(el, keyframes, o);
  }

  /* ---------- Menú lateral ---------- */
  var lastFocus = null;
  var menuOpen = false;
  var menuRun = 0;
  function openMenu() {
    var panel = document.getElementById('vv-menu');
    var veil = document.getElementById('vv-veil');
    if (!panel || !veil) return;
    menuRun++;
    menuOpen = true;
    lastFocus = document.activeElement;
    panel.hidden = false;
    veil.hidden = false;
    document.body.classList.add('vv-locked');
    var close = panel.querySelector('.vv-close');
    if (close) close.focus();
    play(panel, { transform: ['translateX(-100%)', 'none'] }, { duration: 0.3 });
    play(veil, { opacity: [0, 1] }, { duration: 0.2 });
  }
  function closeMenu() {
    var panel = document.getElementById('vv-menu');
    var veil = document.getElementById('vv-veil');
    if (!panel || !menuOpen) return;
    menuOpen = false;
    var run = ++menuRun;
    document.body.classList.remove('vv-locked');
    if (lastFocus) lastFocus.focus();
    function hide() {
      if (run !== menuRun) return;
      panel.hidden = true;
      if (veil) veil.hidden = true;
    }
    var out = play(panel, { transform: ['none', 'translateX(-100%)'] }, { duration: 0.2 });
    play(veil, { opacity: [1, 0] }, { duration: 0.2 });
    if (out) out.then(hide); else hide();
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-vv-menu-open]')) { e.preventDefault(); openMenu(); }
    if (e.target.closest('[data-vv-menu-close]')) closeMenu();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeMenu();
    if (e.key !== 'Tab') return;
    var panel = document.getElementById('vv-menu');
    if (!panel || !menuOpen) return;
    var items = Array.prototype.filter.call(panel.querySelectorAll('a,button'), function (x) { return x.getClientRects().length; });
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ---------- Selector de cantidad (+/−) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-vv-qty]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input[name="quantity"]');
    if (!input) return;
    var min = parseInt(input.min, 10) || 1;
    var max = parseInt(input.max, 10) || 99;
    var value = (parseInt(input.value, 10) || min) + parseInt(btn.dataset.vvQty, 10);
    input.value = Math.max(min, Math.min(max, value));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Galería de producto ---------- */
  function initGallery(root) {
    if (root.dataset.vvReady) return;
    root.dataset.vvReady = 'true';
    var slides = root.querySelector('.vv-slides');
    var thumbs = root.querySelectorAll('.vv-thumbs button');
    var counter = root.querySelector('[data-vv-count]');
    var items = root.querySelectorAll('.vv-slide');
    var total = items.length;
    if (!slides || !total) return;

    function current() { return Math.round(slides.scrollLeft / slides.clientWidth) || 0; }
    function goTo(i) { slides.scrollTo({ left: i * slides.clientWidth, behavior: 'smooth' }); }
    function update() {
      var i = current();
      thumbs.forEach(function (b, j) { b.setAttribute('aria-current', String(i === j)); });
      if (counter) counter.textContent = (i + 1) + ' / ' + total;
    }
    slides.addEventListener('scroll', update, { passive: true });
    thumbs.forEach(function (b, j) { b.addEventListener('click', function () { goTo(j); }); });
    root.querySelectorAll('[data-vv-step]').forEach(function (b) {
      b.addEventListener('click', function () { goTo((current() + parseInt(b.dataset.vvStep, 10) + total) % total); });
    });

    var dialog = root.querySelector('.vv-lightbox');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    var bigImg = dialog.querySelector('img');
    var label = dialog.querySelector('[data-vv-lightbox-count]');
    var zoomIndex = 0;
    function renderZoom() {
      var source = items[zoomIndex].querySelector('img');
      bigImg.src = source.dataset.zoomSrc || source.currentSrc || source.src;
      bigImg.alt = source.alt;
      if (label) label.textContent = (zoomIndex + 1) + ' / ' + total;
    }
    function step(d) {
      zoomIndex = (zoomIndex + d + total) % total;
      renderZoom();
      play(bigImg, { opacity: [0.35, 1], transform: ['translateX(' + d * 8 + 'px)', 'none'] }, { duration: 0.25 });
    }
    items.forEach(function (item, i) {
      var img = item.querySelector('img');
      if (!img) return;
      img.tabIndex = 0;
      img.setAttribute('role', 'button');
      img.setAttribute('aria-label', 'Ampliar: ' + (img.alt || 'foto ' + (i + 1)));
      function open() {
        zoomIndex = i;
        renderZoom();
        dialog.showModal();
        document.body.classList.add('vv-locked');
        play(dialog, { opacity: [0, 1], transform: ['scale(0.98)', 'none'] }, { duration: 0.25 });
      }
      img.addEventListener('click', open);
      img.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); } });
    });
    dialog.querySelector('[data-vv-lightbox-prev]').addEventListener('click', function () { step(-1); });
    dialog.querySelector('[data-vv-lightbox-next]').addEventListener('click', function () { step(1); });
    dialog.querySelector('[data-vv-lightbox-close]').addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('close', function () { document.body.classList.remove('vv-locked'); });
    dialog.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') step(1);
      if (e.key === 'ArrowLeft') step(-1);
    });
  }

  /* ---------- Carrusel de reseñas ---------- */
  function initReviews(root) {
    if (root.dataset.vvReady) return;
    root.dataset.vvReady = 'true';
    var track = root.querySelector('.vv-review-track');
    var position = root.querySelector('.vv-review-position');
    var expand = root.querySelector('.vv-review-expand');
    if (!track) return;
    var cards = track.querySelectorAll('.vv-review-card');
    var count = cards.length;

    function cardWidth() {
      var card = cards[0];
      if (!card) return 1;
      return card.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0);
    }
    function update() {
      if (!position) return;
      if (track.classList.contains('is-expanded')) { position.textContent = count + ' reseñas'; return; }
      var n = Math.max(1, Math.min(count, Math.round(track.scrollLeft / cardWidth()) + 1));
      position.textContent = n + ' / ' + count;
    }
    track.addEventListener('scroll', update, { passive: true });
    root.querySelectorAll('[data-vv-review-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (track.classList.contains('is-expanded')) return;
        track.scrollBy({ left: parseInt(b.dataset.vvReviewStep, 10) * cardWidth(), behavior: 'smooth' });
      });
    });
    if (expand) {
      var closedLabel = expand.textContent;
      expand.addEventListener('click', function () {
        var open = track.classList.toggle('is-expanded');
        expand.setAttribute('aria-expanded', String(open));
        expand.textContent = open ? 'Ver en carrusel' : closedLabel;
        if (!open) track.scrollLeft = 0;
        update();
        Array.prototype.slice.call(cards, 0, 6).forEach(function (card, i) {
          play(card, { opacity: [0, 1], transform: ['translateY(8px)', 'none'] }, { duration: 0.3, delay: i * 0.04 });
        });
      });
    }
    update();
  }

  /* ---------- Barra fija de compra (móvil) ---------- */
  function initSticky(bar) {
    if (bar.dataset.vvReady) return;
    bar.dataset.vvReady = 'true';
    var target = document.getElementById(bar.dataset.target);
    if (!target) return;
    var button = bar.querySelector('button');
    if (button) {
      button.addEventListener('click', function () {
        var submit = target.querySelector('[type="submit"]');
        if (submit && !submit.disabled) submit.click();
        else target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
    function toggle(visible) {
      var was = bar.classList.contains('is-visible');
      bar.classList.toggle('is-visible', visible);
      if (visible && !was) play(bar, { transform: ['translateY(100%)', 'none'] }, { duration: 0.3 });
      document.body.classList.toggle('vv-has-sticky', visible);
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var passed = !entry.isIntersecting;
          toggle(passed);
        });
      }).observe(target);
    }
  }

  /* ---------- Acordeones: el contenido entra suave al abrir ---------- */
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d || d.tagName !== 'DETAILS' || !d.open || !d.closest('.vv-accordion')) return;
    play(d.querySelector('.vv-accordion__content'), { opacity: [0, 1], transform: ['translateY(-4px)', 'none'] }, { duration: 0.25 });
  }, true);

  /* ---------- Entradas al hacer scroll (Motion) ----------
     Solo se preparan los bloques que están por debajo de la primera pantalla
     en el momento de cargar: lo visible nunca se oculta ni se anima (la única
     animación de la primera pantalla es la foto del hero, en CSS). */
  var REVEAL = [
    '.vv-trust__item', '.vv-story', '.vv-gift > *',
    '.vv-selection__heading', '.vv-selection__item',
    '.vv-container > .vv-eyebrow.vv-centered', '.vv-section-title',
    '.vv-reviews__heading', '.vv-reviews__summary', '.vv-review-track', '.vv-review-controls',
    '.vv-faq h2', '.vv-faq details', '.vv-product-grid .vv-card',
    '.vv-how__image', '.vv-related__inner > *'
  ].join(',');
  var revealQueue = [];
  function flushReveal() {
    revealQueue.forEach(function (el, i) {
      var anim = play(el, { opacity: [0, 1], transform: ['translateY(14px)', 'none'] }, { duration: 0.35, delay: Math.min(i, 3) * 0.06 });
      function done() {
        el.style.removeProperty('opacity');
        el.style.removeProperty('transform');
        el.removeAttribute('data-vv-reveal');
      }
      if (anim) anim.then(done); else done();
    });
    revealQueue = [];
  }
  function initReveal(scope) {
    var m = motion();
    if (!m || (window.Shopify && window.Shopify.designMode)) return;
    var fold = window.innerHeight;
    (scope || document).querySelectorAll(REVEAL).forEach(function (el) {
      if (el.hasAttribute('data-vv-reveal') || el.parentElement.closest('[data-vv-reveal]')) return;
      var rect = el.getBoundingClientRect();
      if (!rect.height || rect.top < fold) return;
      el.setAttribute('data-vv-reveal', '');
      el.style.opacity = '0';
      el.style.transform = 'translateY(14px)';
      m.inView(el, function () {
        if (!revealQueue.length) setTimeout(flushReveal, 0);
        revealQueue.push(el);
      }, { margin: '0px 0px -6% 0px' });
    });
  }

  /* ---------- Escena ligada al scroll (GSAP + ScrollTrigger) ----------
     Una sola escena en todo el tema: la línea de «Así de sencillo».
     GSAP solo se descarga cuando esa sección se acerca a la pantalla. */
  var gsapReady = null;
  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = src;
      s.onload = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }
  function loadGsap(root) {
    if (window.gsap && window.ScrollTrigger) return Promise.resolve();
    if (!gsapReady) {
      gsapReady = loadScript(root.dataset.gsap).then(function () { return loadScript(root.dataset.scrollTrigger); });
    }
    return gsapReady;
  }
  function startScene(root) {
    var gsap = window.gsap;
    var ScrollTrigger = window.ScrollTrigger;
    var fill = root.querySelector('.vv-steps__progress > i');
    if (!gsap || !ScrollTrigger || !fill) return;
    gsap.registerPlugin(ScrollTrigger);
    root.classList.add('is-scene');
    gsap.fromTo(fill, { scaleY: 0 }, {
      scaleY: 1,
      ease: 'none',
      scrollTrigger: { trigger: root, start: 'top 70%', end: 'bottom 55%', scrub: 0.3 }
    });
    root.querySelectorAll('article').forEach(function (step) {
      ScrollTrigger.create({
        trigger: step,
        start: 'top 62%',
        onEnter: function () { step.classList.add('is-active'); },
        onLeaveBack: function () { step.classList.remove('is-active'); }
      });
    });
  }
  function initScene(root) {
    if (root.dataset.vvReady || prefersReduced() || !('IntersectionObserver' in window)) return;
    root.dataset.vvReady = 'true';
    var io = new IntersectionObserver(function (entries) {
      if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
      io.disconnect();
      loadGsap(root).then(function () { startScene(root); }).catch(function () {});
    }, { rootMargin: '800px 0px' });
    io.observe(root);
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-vv-gallery]').forEach(initGallery);
    (scope || document).querySelectorAll('[data-vv-reviews]').forEach(initReviews);
    (scope || document).querySelectorAll('[data-vv-sticky]').forEach(initSticky);
    (scope || document).querySelectorAll('[data-vv-scroll-scene]').forEach(initScene);
    initReveal(scope);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  /* Selector de packs de la tarjeta del catálogo: variante y precio del botón */
  function syncPack(input) {
    var box = input.closest('.vv-card__actions');
    var group = input.closest('[data-vv-packs]');
    if (!box || !group) return;
    var idField = box.querySelector('form input[name="id"]');
    if (idField) idField.value = input.value;
    var label = box.querySelector('form button[name="add"] > span:first-child');
    if (label) label.textContent = group.dataset.label + (group.hasAttribute('data-hide-price') ? '' : ' · ' + input.dataset.price);
  }
  document.addEventListener('change', function (e) {
    var input = e.target.closest && e.target.closest('.vv-pack__input');
    if (input && input.checked) syncPack(input);
  });
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('.vv-pack__input:checked').forEach(syncPack);
  });
})();
